import { TabPanel } from '@/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PricingSpecialRequestListPanel } from './PricingSpecialRequestListPanel';
import { PricingSpecialRequestListFilterPanel } from './PricingSpecialRequestListFilterPanel';

interface Props {
  communityId: string;
}

export function PricingSpecialRequestListTabPanel(props: Props) {
  const { communityId } = props;
  const { t } = useTranslation();
  const [selectedProjectIds, setSelectedProjectIds] = useState<string[]>();
  const [selectedHomeIds, setSelectedHomeIds] = useState<string[]>();

  return (
    <TabPanel>
      <TabPanel.Title>{t('pricing.specialRequest.title')}</TabPanel.Title>
      <TabPanel.Body>
        <PricingSpecialRequestListFilterPanel
          communityId={communityId}
          selectedProjectIds={selectedProjectIds}
          onSelectedProjectIdsChange={setSelectedProjectIds}
          selectedHomeIds={selectedHomeIds}
          onSelectedHomeIdsChange={setSelectedHomeIds}
        />
        <PricingSpecialRequestListPanel
          className="mt-4"
          communityId={communityId}
          homeIds={selectedHomeIds}
          projectIds={selectedProjectIds}
        />
      </TabPanel.Body>
    </TabPanel>
  );
}
